const queryStrBuilder = (obj) => {
    if (typeof obj !== 'object') {
        throw 'Not an Object. Object expected, passed: ' + typeof obj + ' to queryStrBuilder.';
    }
    if (Object.keys(obj).length === 0)
        return '';
    let queryString = '?';
    const builder = [];
    keyBuilder(obj, builder);
    queryString += builder.join('&');
    return queryString;
};

const keyBuilder = (obj, builder, str) => {
    let subKeys = '';
    let newStr = str;
    for (let elem in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, elem)) {
            if (!str) newStr = elem;
            else subKeys = `[${elem}]`;

            if (typeof obj[elem] === 'object')
                keyBuilder(obj[elem], builder, (newStr + subKeys));
            else
                builder.push(newStr + subKeys + '=' + encodeURIComponent(obj[elem])
                    .replaceAll('%2C', ',')
                    .replaceAll('%2B', '+'));
        }
    }
};

export default queryStrBuilder;